import { useUpdatePartCategoriesJob } from './useUpdatePartCategoriesJob';

export const useCancelPartsCategoriesJob = () => {
  const { mutateAsync: updatePartCategoriesJob } = useUpdatePartCategoriesJob();

  const cancelJob = async (accountId: string, runID: string) => {
    await updatePartCategoriesJob({ runID, accountId, status: 'CANCELLED_BY_USER' });
  };

  return { cancelJob };
};
